// The pure half of the MSQA template-family picker (review #32): which
// templates the "New ..." buttons offer. No DOM (frontend/tests).

/** Review #32 (Connor: "they can choose between them per document"): the
 * organisation's template families and its default (/api/msqa/templates). */
export interface TemplateFamilies {
  families: { key: string; label: string; n_templates: number }[];
  default: string | null;
}
/** Which templates the "New ..." buttons offer: the picked family (or the
 * organisation's default; "all" when it has none), plus the picker itself
 * when there is more than one family to choose from. */
export function familyChoice<T extends { family?: string }>(templates: T[], fams: TemplateFamilies | null, picked: string | null):
    { shown: T[]; options: { key: string; label: string }[]; active: string } {
  const list = (fams?.families ?? []).filter((f) => templates.some((t) => (t.family ?? "wrap") === f.key));
  if (list.length < 2) return { shown: templates, options: [], active: "all" };
  const options = [...(fams?.default ? [] : [{ key: "all", label: "All" }]), ...list.map((f) => ({ key: f.key, label: f.label }))];
  const active = picked && options.some((o) => o.key === picked) ? picked : (fams?.default ?? "all");
  return { shown: active === "all" ? templates : templates.filter((t) => (t.family ?? "wrap") === active), options, active };
}
